import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const SocialRegistration = () => {
  const navigate = useNavigate();
  const [loadingProvider, setLoadingProvider] = useState(null);

  const socialProviders = [
    {
      id: 'google',
      name: 'Google',
      icon: 'Mail',
      color: 'bg-white hover:bg-gray-50 text-gray-700 border border-border',
      textColor: 'text-gray-700'
    },
    {
      id: 'apple',
      name: 'Apple',
      icon: 'Smartphone',
      color: 'bg-gray-900 hover:bg-gray-800 text-white',
      textColor: 'text-white'
    }
  ];

  const handleSocialLogin = async (provider) => {
    setLoadingProvider(provider?.id);

    try {
      // Simulate social login API call
      await new Promise(resolve => setTimeout(resolve, 1500));
      
      // Mock successful social registration
      console.log(`Registration with ${provider?.name} successful`);
      
      // Navigate to dashboard after successful registration
      navigate('/dashboard');
    } catch (error) {
      console.error(`${provider?.name} registration failed:`, error);
    } finally {
      setLoadingProvider(null);
    }
  };

  return (
    <div className="space-y-4">
      <div className="text-center">
        <p className="text-sm text-text-secondary mb-4">
          Sign up quickly with your existing account
        </p>
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
        {socialProviders?.map((provider) => (
          <Button
            key={provider?.id}
            variant="outline"
            size="default"
            onClick={() => handleSocialLogin(provider)}
            loading={loadingProvider === provider?.id}
            disabled={loadingProvider !== null}
            className={`${provider?.color} transition-micro hover-lift`}
          >
            <div className="flex items-center justify-center space-x-2">
              <Icon 
                name={provider?.icon} 
                size={18} 
                className={provider?.textColor}
              />
              <span className={`font-medium ${provider?.textColor}`}>
                {loadingProvider === provider?.id ? 'Connecting...' : `Continue with ${provider?.name}`}
              </span>
            </div>
          </Button>
        ))}
      </div>
      {/* Divider */}
      <div className="relative my-6">
        <div className="absolute inset-0 flex items-center">
          <div className="w-full border-t border-border" />
        </div>
        <div className="relative flex justify-center text-sm">
          <span className="px-4 bg-background text-text-secondary">
            Or continue with email
          </span>
        </div>
      </div>
    </div>
  );
};

export default SocialRegistration;